import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, FlexBox } from '@eltoro-ui/components';

import CustomIcons from 'assets/icons';

import './ContactsSeen.scss';

const ContactsSeen = () => {
  const history = useHistory();

  return (
    <div className="contact-seen">
      <div className="contact-seen-content">
        <FlexBox flexDirection="column" gap="0.5rem">
          <span className="contact-seen-title">Engage with your contacts</span>
          <div className="contact-seen-description">
            Sync or upload your contacts to reach your most valuable audience.
          </div>
        </FlexBox>
        <Button
          UNSAFE_className="upgrade-button"
          size="l"
          weight="bold"
          onClick={() => history.push('/my-contacts')}
        >
          Go to my Contacts
        </Button>
      </div>
      <div className="contact-seen-icon">
        <CustomIcons name="contact_seen" fontSize={130} />
      </div>
    </div>
  );
};

export default ContactsSeen;
